var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "32px",
    viewBox: "0 0 23 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.01081538,2.75530769 C4.67944615,2.76446154 4.00206154,2.77910769 3.74758462,2.78276923 L3.74758462,2.78276923 C1.88386154,2.82670769 2.22804615,1.37856923 2.22804615,1.37856923 L2.22804615,1.37856923 C0.937353846,2.0944 0.0457692308,3.69998462 0.446707692,4.82773846 L0.446707692,4.82773846 C2.00835385,9.23073846 7.83569231,6.15138462 9.639,6.00492308 L9.639,6.00492308 L14.994,5.14446154 L14.7230462,5.13896923 L14.7230462,5.13713846 L15.4297231,5.12066154 C15.7610923,5.11516923 16.4348154,5.10052308 16.6929538,5.0932 L16.6929538,5.0932 C18.5566769,5.05292308 18.2106615,6.4974 18.2106615,6.4974 L18.2106615,6.4974 C18.4980923,6.33812308 18.7324308,6.14772308 18.9246615,5.93718462 L18.9246615,5.93718462 L20.2812615,2.10904615 L20.0322769,0.840323077 L19.5471231,0.483323077 L5.01081538,2.75530769 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "115.158545%",
    y1: "50.8345337%",
    x2: "-11.6954707%",
    y2: "49.0160804%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25376F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3266AD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.313061538,3.27118462 L2.92923077,5.94593846 C3.53887692,6.01916923 4.18330769,6.01001538 4.78196923,5.9972 L4.78196923,5.9972 L13.8625846,5.79764615 C14.1939538,5.79032308 14.8695077,5.77567692 15.1294769,5.77018462 L15.1294769,5.77018462 C15.8672769,5.75187692 16.2590615,5.97156923 16.4604462,6.23886154 L16.4604462,6.23886154 L17.0591077,2.38326154 L15.351,1.27381538 C14.7376923,1.19875385 14.1005846,1.24086154 13.4982615,1.25367692 L13.4982615,1.25367692 L12.4016308,1.27930769 L4.41764615,1.45323077 C4.08444615,1.46055385 3.40889231,1.4752 3.15075385,1.48069231 L3.15075385,1.48069231 C2.12918462,1.50449231 1.77218462,1.07975385 1.65867692,0.691630769 L1.65867692,0.691630769 L0.313061538,3.27118462 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "109.444189%",
    y1: "51.0922262%",
    x2: "-9.61937466%",
    y2: "49.4114762%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25376F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3266AD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.97809231,2.34887692 C7.74375385,2.45506154 7.12312308,2.72784615 6.82104615,2.86149231 L6.82104615,2.86149231 L6.17844615,3.14709231 L6.17661538,3.14709231 L2.77504615,4.82956923 C0.986384615,5.62046154 -0.670461538,6.12392308 0.288861538,8.67967692 L0.288861538,8.67967692 C0.709938462,9.80010769 1.50998462,10.8857538 2.98375385,10.9846154 L2.98375385,10.9846154 C2.98375385,10.9846154 2.05738462,9.82207692 3.76,9.0678 L3.76,9.0678 C3.99433846,8.96527692 4.61313846,8.69066154 4.91704615,8.55518462 L4.91704615,8.55518462 L5.55964615,8.27324615 L8.42296923,7.13084615 C10.2134615,6.33812308 12.4085538,5.29458462 11.4510615,2.73883077 L11.4510615,2.73883077 C11.0281538,1.6184 10.2262769,0.532753846 8.75433846,0.433892308 L8.75433846,0.433892308 C8.75433846,0.433892308 9.68253846,1.59643077 7.97809231,2.34887692",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.76715926%",
    y1: "80.2789298%",
    x2: "95.374515%",
    y2: "27.0086243%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39549F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C2E7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.1075077,2.39830769 C14.8731692,2.50083077 14.2525385,2.77544615 13.9504615,2.91092308 L13.9504615,2.91092308 L8.54969231,5.3312 L3.46747692,7.58487692 C1.67698462,8.37576923 -0.519938462,9.41930769 0.439384615,11.9732308 L0.439384615,11.9732308 C0.862292308,13.0936615 1.66233846,14.1921231 3.13427692,14.2909846 L3.13427692,14.2909846 C3.13427692,14.2909846 2.20790769,13.1174615 3.91052308,12.3631846 L3.91052308,12.3631846 C4.14486154,12.2588308 4.76549231,11.9860462 5.06756923,11.8524 L5.06756923,11.8524 L10.4024308,9.48704615 L10.4024308,9.48521538 L14.5472923,7.62149231 L15.5505538,7.17844615 C17.3410462,6.38572308 19.5379692,5.34218462 18.5786462,2.78643077 L18.5786462,2.78643077 C18.1594,1.66783077 17.3556923,0.580353846 15.8855846,0.481492308 L15.8855846,0.481492308 C15.8855846,0.481492308 16.8101231,1.64403077 15.1075077,2.39830769",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.76715926%",
    y1: "70.4294173%",
    x2: "95.374515%",
    y2: "34.4875492%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39549F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C2E7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4289231,2.57772308 C17.1927538,2.68207692 16.5739538,2.95486154 16.2718769,3.09033846 L16.2718769,3.09033846 L10.8692769,5.51061538 L3.03724615,9.05864615 C1.24492308,9.85136923 -0.463184615,11.4331538 0.496138462,13.9889077 L0.496138462,13.9889077 C0.915384615,15.1093385 1.71726154,16.2059692 3.1892,16.3048308 L3.1892,16.3048308 C3.1892,16.3048308 2.26283077,15.1313077 3.96544615,14.3788615 L3.96544615,14.3788615 C4.20344615,14.2726769 7.57206154,12.7055385 7.87596923,12.5718923 L7.87596923,12.5718923 L13.2108308,10.2047077 L17.3575231,8.34281538 L18.3589538,7.89793846 C20.1494462,7.10521538 22.3445385,6.06350769 21.3852154,3.50775385 L21.3852154,3.50775385 C20.9659692,2.38732308 19.6789385,0.7616 18.207,0.662738462 L18.207,0.662738462 C18.207,0.662738462 19.1333692,1.82344615 17.4289231,2.57772308",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-10.3096171%",
    y1: "69.9551299%",
    x2: "94.7501547%",
    y2: "34.5848967%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39549F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C2E7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.98924615,0.699353846 C2.97316923,0.714 1.96075385,1.10944615 1.18450769,1.88386154 L1.18450769,1.88386154 C0.408261538,2.66010769 0.0146461538,3.67252308 0,4.6886 L0,4.6886 L0,4.80027692 C0.0146461538,5.81635385 0.408261538,6.82876923 1.18450769,7.60501538 L1.18450769,7.60501538 C2.76446154,9.18496923 5.32570769,9.18496923 6.90566154,7.60501538 L6.90566154,7.60501538 C8.48561538,6.02506154 8.48561538,3.46381538 6.90566154,1.88386154 L6.90566154,1.88386154 C6.12941538,1.10944615 5.117,0.714 4.10092308,0.699353846 L4.10092308,0.699353846 L3.98924615,0.699353846 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-67.6254025%",
    y1: "49.9999615%",
    x2: "135.248601%",
    y2: "49.9999615%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39549F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C2E7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "404px---Iphone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Welcome:Invited:iphone:320px",
    transform: "translate(-196.000000, -3915.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 3862.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logotype-Copy",
    transform: "translate(163.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(33.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 10.984615)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01081538,2.75530769 C4.67944615,2.76446154 4.00206154,2.77910769 3.74758462,2.78276923 L3.74758462,2.78276923 C1.88386154,2.82670769 2.22804615,1.37856923 2.22804615,1.37856923 L2.22804615,1.37856923 C0.937353846,2.0944 0.0457692308,3.69998462 0.446707692,4.82773846 L0.446707692,4.82773846 C2.00835385,9.23073846 7.83569231,6.15138462 9.639,6.00492308 L9.639,6.00492308 L14.994,5.14446154 L14.7230462,5.13896923 L14.7230462,5.13713846 L15.4297231,5.12066154 C15.7610923,5.11516923 16.4348154,5.10052308 16.6929538,5.0932 L16.6929538,5.0932 C18.5566769,5.05292308 18.2106615,6.4974 18.2106615,6.4974 L18.2106615,6.4974 C18.4980923,6.33812308 18.7324308,6.14772308 18.9246615,5.93718462 L18.9246615,5.93718462 L20.2812615,2.10904615 L20.0322769,0.840323077 L19.5471231,0.483323077 L5.01081538,2.75530769 Z",
    id: "Fill-1",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(3.661538, 19.307692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.313061538,3.27118462 L2.92923077,5.94593846 C3.53887692,6.01916923 4.18330769,6.01001538 4.78196923,5.9972 L4.78196923,5.9972 L13.8625846,5.79764615 C14.1939538,5.79032308 14.8695077,5.77567692 15.1294769,5.77018462 L15.1294769,5.77018462 C15.8672769,5.75187692 16.2590615,5.97156923 16.4604462,6.23886154 L16.4604462,6.23886154 L17.0591077,2.38326154 L15.351,1.27381538 C14.7376923,1.19875385 14.1005846,1.24086154 13.4982615,1.25367692 L13.4982615,1.25367692 L12.4016308,1.27930769 L4.41764615,1.45323077 C4.08444615,1.46055385 3.40889231,1.4752 3.15075385,1.48069231 L3.15075385,1.48069231 C2.12918462,1.50449231 1.77218462,1.07975385 1.65867692,0.691630769 L1.65867692,0.691630769 L0.313061538,3.27118462 Z",
    id: "Fill-4",
    fill: "url(#linearGradient-6)",
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.153846, 20.138462)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97809231,2.34887692 C7.74375385,2.45506154 7.12312308,2.72784615 6.82104615,2.86149231 L6.82104615,2.86149231 L6.17844615,3.14709231 L6.17661538,3.14709231 L2.77504615,4.82956923 C0.986384615,5.62046154 -0.670461538,6.12392308 0.288861538,8.67967692 L0.288861538,8.67967692 C0.709938462,9.80010769 1.50998462,10.8857538 2.98375385,10.9846154 L2.98375385,10.9846154 C2.98375385,10.9846154 2.05738462,9.82207692 3.76,9.0678 L3.76,9.0678 C3.99433846,8.96527692 4.61313846,8.69066154 4.91704615,8.55518462 L4.91704615,8.55518462 L5.55964615,8.27324615 L8.42296923,7.13084615 C10.2134615,6.33812308 12.4085538,5.29458462 11.4510615,2.73883077 L11.4510615,2.73883077 C11.0281538,1.6184 10.2262769,0.532753846 8.75433846,0.433892308 L8.75433846,0.433892308 C8.75433846,0.433892308 9.68253846,1.59643077 7.97809231,2.34887692",
    id: "Fill-7",
    fill: "url(#linearGradient-9)",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(3.661538, 10.984615)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1075077,2.39830769 C14.8731692,2.50083077 14.2525385,2.77544615 13.9504615,2.91092308 L13.9504615,2.91092308 L8.54969231,5.3312 L3.46747692,7.58487692 C1.67698462,8.37576923 -0.519938462,9.41930769 0.439384615,11.9732308 L0.439384615,11.9732308 C0.862292308,13.0936615 1.66233846,14.1921231 3.13427692,14.2909846 L3.13427692,14.2909846 C3.13427692,14.2909846 2.20790769,13.1174615 3.91052308,12.3631846 L3.91052308,12.3631846 C4.14486154,12.2588308 4.76549231,11.9860462 5.06756923,11.8524 L5.06756923,11.8524 L10.4024308,9.48704615 L10.4024308,9.48521538 L14.5472923,7.62149231 L15.5505538,7.17844615 C17.3410462,6.38572308 19.5379692,5.34218462 18.5786462,2.78643077 L18.5786462,2.78643077 C18.1594,1.66783077 17.3556923,0.580353846 15.8855846,0.481492308 L15.8855846,0.481492308 C15.8855846,0.481492308 16.8101231,1.64403077 15.1075077,2.39830769",
    id: "Fill-10",
    fill: "url(#linearGradient-12)",
    mask: "url(#mask-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 1.830769)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4289231,2.57772308 C17.1927538,2.68207692 16.5739538,2.95486154 16.2718769,3.09033846 L16.2718769,3.09033846 L10.8692769,5.51061538 L3.03724615,9.05864615 C1.24492308,9.85136923 -0.463184615,11.4331538 0.496138462,13.9889077 L0.496138462,13.9889077 C0.915384615,15.1093385 1.71726154,16.2059692 3.1892,16.3048308 L3.1892,16.3048308 C3.1892,16.3048308 2.26283077,15.1313077 3.96544615,14.3788615 L3.96544615,14.3788615 C4.20344615,14.2726769 7.57206154,12.7055385 7.87596923,12.5718923 L7.87596923,12.5718923 L13.2108308,10.2047077 L17.3575231,8.34281538 L18.3589538,7.89793846 C20.1494462,7.10521538 22.3445385,6.06350769 21.3852154,3.50775385 L21.3852154,3.50775385 C20.9659692,2.38732308 19.6789385,0.7616 18.207,0.662738462 L18.207,0.662738462 C18.207,0.662738462 19.1333692,1.82344615 17.4289231,2.57772308",
    id: "Fill-13",
    fill: "url(#linearGradient-15)",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98924615,0.699353846 C2.97316923,0.714 1.96075385,1.10944615 1.18450769,1.88386154 L1.18450769,1.88386154 C0.408261538,2.66010769 0.0146461538,3.67252308 0,4.6886 L0,4.6886 L0,4.80027692 C0.0146461538,5.81635385 0.408261538,6.82876923 1.18450769,7.60501538 L1.18450769,7.60501538 C2.76446154,9.18496923 5.32570769,9.18496923 6.90566154,7.60501538 L6.90566154,7.60501538 C8.48561538,6.02506154 8.48561538,3.46381538 6.90566154,1.88386154 L6.90566154,1.88386154 C6.12941538,1.10944615 5.117,0.714 4.10092308,0.699353846 L4.10092308,0.699353846 L3.98924615,0.699353846 Z",
    id: "Fill-16",
    fill: "url(#linearGradient-18)",
    mask: "url(#mask-17)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.25d51442760f528956240cfc779a77b7.svg";
export { ForwardRef as ReactComponent };